import { Component } from '@angular/core';
import { MessageFormComponent } from '../../../../../components/forms/campaignforms/message-form/message-form.component';
import { MessagesPreviewComponent } from '../../../../../components/forms/campaignpreviews/messages-preview/messages-preview.component';
import { CampaignMessagesComponent } from '../../../../../components/forms/campaignpreviews/campaign-messages/campaign-messages.component';
import { EditMessageFormComponent } from '../../../../../components/forms/campaignforms/edit-message-form/edit-message-form.component';
import { TestMessageComponent } from '../../../../../components/forms/campaignforms/test-message/test-message.component';

/** Wizard step 3: write messages; the draft previews live beside the form. */
@Component({
  selector: 'app-messages',
  standalone: true,
  imports: [
    MessageFormComponent,
    MessagesPreviewComponent,
    CampaignMessagesComponent,
    EditMessageFormComponent,
    TestMessageComponent,
  ],
  templateUrl: './messages.component.html',
  styleUrl: '../wizard-step.css',
})
export class MessagesComponent {
  openEditPopup = false;
  testMessage = false;
  fromEdit = false;
  editMessageNo: string | number = 1;

  openPopup(msgNo: number | string) {
    this.openEditPopup = true;
    this.editMessageNo = msgNo;
  }

  closePopup(event: boolean) {
    this.openEditPopup = event;
  }

  showTestMessage(fromEdit: boolean) {
    this.fromEdit = fromEdit;
    this.testMessage = true;
  }

  closeTestMessage() {
    this.testMessage = false;
  }
}
